import { Grid, Typography } from '@material-ui/core';
import { FuncaoParticipante, ParticipanteResponse } from 'common/genericTypes';
import { MdSpace, TextField, Dropdown } from 'm2m.components';
import React, { useCallback, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { RootState } from 'store';
import { updateId, updateCodigoExterno } from 'store/modules/cra/emissor';
import { labelsEmissor as labels } from '../labels';

const mapStateToProps = (state: RootState) => ({
  emissorId: state.craCadastro.emissor.id,
  codigoExterno: state.craCadastro.emissor.codigoExterno,
  participanteApi: state.participanteApi,
});

const mapDispatchToProps = { updateId, updateCodigoExterno };

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;

const ValidacapEmissor: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const {
    updateId,
    updateCodigoExterno,
    emissorId,
    codigoExterno,
    participanteApi: { getParticipantes },
  } = props;

  const [emissores, setEmissores] = useState<Array<ParticipanteResponse>>([]);

  const getEmissores = useCallback(async () => {
    try {
      const result = await getParticipantes(dispatch, { funcao: FuncaoParticipante.Emissor, suspenso: false });
      setEmissores(result);
    } catch (error) {}
  }, [dispatch, getParticipantes]);

  useEffect(() => {
    getEmissores();
  }, [getEmissores]);

  return (
    <>
      <Grid container justify="center">
        <Grid item sm={4}>
          <Typography variant="h3" align="center">
            {'Antes de começar, nos informe o Emissor e o código do CRA a ser cadastrado:'}
          </Typography>
          <MdSpace />
          <Dropdown
            label={labels.emissor}
            onChange={(value) => updateId(value)}
            options={emissores.map((emissor) => {
              return { description: emissor.razaoSocial, value: emissor.id };
            })}
            required
            value={emissorId}
          />
          <MdSpace />
          <TextField
            label={labels.codigoExterno}
            value={codigoExterno}
            onChange={(value) => updateCodigoExterno(value)}
            required
          />
          <MdSpace />
        </Grid>
      </Grid>
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ValidacapEmissor);
